import React, { Component } from 'react';
import _ from 'lodash';
import config from '../config';
import {
    Link,
    Redirect
} from "react-router-dom";
import {AuthContext} from "../context/auth";
import fetcher from "../context/fetcher";
import {downloadFile, readFileAsync} from "../components/ImportExport";

export default class UserSaveVars extends Component {
    static contextType = AuthContext
    constructor(props, context) {
        super(props);
        this.authContext = context;
        this.state = {
            vars: null
        }
        this.remove = this.remove.bind(this)
        this.add = this.add.bind(this)
        this.handleChange = this.handleChange.bind(this)
        this.remove = this.remove.bind(this)
        this.getStore();
    }
    getStore()  {
        fetcher(`${config.API()}collection/user-save-vars`)
            .then(response => response.json())
            .then(data => {
                this.setState({vars: data})
            });
    }

    remove = (eventId) => {
        return (e) => {
            let isOk = window.confirm("Are you sure?");
            if(!isOk)
                return;
            e.preventDefault();
            if (!e) e = window.event;                // Get the window event
            e.cancelBubble = true;                       // IE Stop propagation
            if (e.stopPropagation) e.stopPropagation();  // Other Broswers
            fetcher(`${config.API()}collection/user-save-vars/remove/${eventId}`,{
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body:"{}"
            })
                .then(response => response.json())
                .then(data => {
                    this.getStore();
                });
        }
    }
    add = (e) => {
        e.preventDefault();
        if (!e) e = window.event;                // Get the window event
        e.cancelBubble = true;                       // IE Stop propagation
        if (e.stopPropagation) e.stopPropagation();  // Other Broswers
        let data = JSON.parse(JSON.stringify(this.state.vars)) || []
        let id = Math.floor(Math.random()*100000)
        data.push({_id: id, key: "", value:"", valueType:"int"})
        this.setState({vars: data})
    }
    save = (id) => {
        return (e) => {
            e.preventDefault();
            if (!e) e = window.event;                // Get the window event
            e.cancelBubble = true;                       // IE Stop propagation
            if (e.stopPropagation) e.stopPropagation();  // Other Broswers
            let obj = _.find(this.state.vars, x=>x._id == id);
            console.log(obj);
            fetcher(`${config.API()}collection/user-save-vars/save`,{
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(obj)
            })
                .then(response => response.json())
                .then(data => {
                    this.getStore();
                });
        }
    }
    handleChange = (id) => {
        return (e) => {
            e.preventDefault();
            if (!e) e = window.event;                // Get the window event
            e.cancelBubble = true;                       // IE Stop propagation
            if (e.stopPropagation) e.stopPropagation();  // Other Broswers
            let data = _.cloneDeep(this.state.vars)
            let obj = _.find(data, x=>x._id == id);
            obj[e.target.name] =  e.target.value
            this.setState({vars: data})
        }
    }
    exportObjs = () => downloadFile(JSON.stringify(this.state.vars, null, "\t"), "vars.json", 'text/plain')

    importObjs = async (e) => {
        let text = await readFileAsync(e)
        let objs = JSON.parse(text)
        for(let v of this.state.vars){
            for(let o of objs){
                if(v.key == o.key){
                    o._id = v._id
                }
            }
        }
        this.setState({vars: objs})
        await fetcher(`${config.API()}collection/user-save-vars/import`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(objs)
        })
    }
    render() {

        if (this.state.redirect) {
            return <Redirect push to={this.state.redirect} />;
        }

        let list = [];
        if(this.state && this.state.vars != null && Object.keys(this.state.vars).length > 0) {
            let sorted = _.sortBy(this.state.vars, ['key'])
            let n=0;
            while (sorted[0].key == "" && n < 100) {
                let tmp = sorted.shift();
                sorted.push(tmp);
                n += 1;
            }

            for(let x of sorted){
                // let x = this.state.vars[k]
                list.push(
                    <tr className={(x.active ? "active" : "")} key={x._id}>
                        <td>{x._id}</td>
                        <td>
                            <input type="text"
                                   name = "key"
                                   className="form-control"
                                   onChange={this.handleChange(x._id)}
                                   value={x.key}
                            />

                        </td>
                        <td>

                            { !x.read && <input type="text"
                                                name = "value"
                                                className="form-control"
                                                onChange={this.handleChange(x._id)}
                                                value={x.value}
                            />}
                            {x.read && <div>{x.value}</div>}
                        </td>
                        <td>
                            { !x.read &&  <select name = "valueType" className="form-control" onChange={this.handleChange(x._id)}>
                                <option value="int" selected={x.valueType == "int"}>int</option>
                                <option value="string" selected={x.valueType== "string"}>string</option>
                                <option value="double" selected={x.valueType == "double"}>double</option>
                                <option value="datetime" selected={x.valueType == "datetime"}>datetime</option>
                            </select>}
                            {x.read && <div>{x.valueType}</div>}
                        </td>
                        <td>
                            <button className="btn btn-outline-danger btn-circle btn-sm" onClick={this.remove(x._id)} ><i className="fa fa-remove"></i></button>
                            {!x.read && <button className="btn btn-outline-primary btn-circle btn-sm" onClick={this.save(x._id)} ><i className="fa fa-save"></i></button>}
                        </td>
                    </tr>
                )
            }
        }
        let film = _.find(this.state.vars, x => x.key=="film");
        return (
            <div className="card shadow w100">
                <div className="card-header py-3">
                    <h2 className="m-0 font-weight-bold l"> UserSave Vars {this.authContext.username == "strigin.roman@gmail.com" && film && <a href={film.value} target="_blank">Film</a>}</h2>
                    <input onChange={this.importObjs} type="file" id="file-input" className="r btn btn-icon btn-light ml-1"/>
                    <button onClick={this.exportObjs} className="r btn btn-icon btn-light  ml-1"><i className="fas fa-fw fa-arrow-circle-down "></i> Export </button>
                </div>
                <div className="card-body">
                    <div className="table-responsive">
                        <table className="dataTable table table-align-middle table-bordered table-sm" width="100%"
                               cellSpacing="0">
                            <thead>
                            <tr>
                                <th>ID</th>
                                <th>Key</th>
                                <th>Value</th>
                                <th>ValueType</th>
                                <th></th>
                            </tr>
                            </thead>
                            <tbody>
                            {list}
                            </tbody>
                        </table>
                    </div>
                    <div className="r">
                        <button onClick={this.add} className="btn btn-icon btn-primary ml-1"><i className="fas fa-fw fa-plus-square"></i> Add </button>
                    </div>
                </div>
            </div>
        );
    }
}